import { render } from "./Image.vue?vue&type=template&id=664ba529&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=664ba529&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-664ba529"

export default script